/**
 * PrivateRoute
 *
 * A wrapper for any Route that checks that the user is authenticated
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Route, Redirect } from 'react-router-dom';

// Selectors
import { selectIsAuthenticated } from '../../../../services/auth/selectors';

const PrivateRoute = ({ component: Component, isAuthenticated, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: '/login',
                        state: { from: props.location }
                    }}
                />
            )
        }
    />
);

PrivateRoute.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired
};

const mapStateToProps = createStructuredSelector({
    isAuthenticated: selectIsAuthenticated
});

export default connect(mapStateToProps)(PrivateRoute);
